import authApi from 'api/authApi';
import { removeAxiosAccessToken } from 'api/axiosClient';
import store from 'app/store';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import _ from 'lodash';
import { thunkLogIn } from './maintainerAuthSlice';
import maintainerApi from 'api/maintainerApi';
import ToastHelper from 'general/helpers/ToastHelper';
import { thunkLogInMaintainer } from 'features/Auth/authSlice';

const MaintainerAuthHelper = {
  // ---- methods ----
  callApiLogIn: (params) => {
    store.dispatch(thunkLogInMaintainer(params));
  },

  callApiRegister: async (params) => {
    try {
      const res = await maintainerApi.signUp(params);
      const { result, reason, maintainer } = res;
      return { result, reason, maintainer };
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
      return false;
    }
  },

  checkAccessTokenValid: () => {
    const accessToken = localStorage.getItem(PreferenceKeys.maintainerAccessToken);
    return !_.isUndefined(accessToken) && !_.isNull(accessToken);
  },

  signOut: () => {
    localStorage.removeItem(PreferenceKeys.maintainerAccessToken);
    localStorage.removeItem(PreferenceKeys.accessTokenExpired);
    removeAxiosAccessToken();
  },

  callApiChangePassword: async (params) => {
    try {
      const res = await maintainerApi.changePassword(params);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
      return false;
    }
  },

  callApiForgotPassword: async (params) => {
    try {
      const res = await maintainerApi.forgotPassword(params);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
      return false;
    }
  },

  callApiResetPasswordUser: async (params) => {
    try {
      const res = await maintainerApi.resetPasswordUser(params);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
      return false;
    }
  },
};

export default MaintainerAuthHelper;
